import { DeliveryZone, Store as StoreModel } from '@core/models';
import { OrderTypeEnum } from '@core/enums';
import { StoreProcessingInput, StoreProcessingResult, StoreProcessingStrategy } from '../interfaces';
import {
	calculateDistanceInKm,
	evaluateStoreDeliveryAvailability,
	isStoreInSameCountry,
	isStoreWithinMaxDistance,
} from '../rules';

export class DeliveryStoresStrategy implements StoreProcessingStrategy {
	readonly code = OrderTypeEnum.Delivery;

	process(input: StoreProcessingInput): StoreProcessingResult {
		const { stores, userLocation, userCountry, isPointInShape } = input;
		const deliveryStores: StoreModel[] = [];
		let deliveryZonesAvailable: DeliveryZone[] = [];

		for (const store of stores ?? []) {
			if (!isStoreInSameCountry(userCountry, store.ubicacion?.pais)) {
				continue;
			}

			let distancia = 0;
			if (
				store.location &&
				typeof store.location.lat === 'number' &&
				typeof store.location.lng === 'number'
			) {
				distancia = calculateDistanceInKm(
					userLocation.lat,
					userLocation.lng,
					store.location.lat,
					store.location.lng
				);
				if (!isStoreWithinMaxDistance(distancia)) {
					continue;
				}
			}

			const storeWithDistance = { ...store, distancia };

			const { isAvailable, matchedZones } = evaluateStoreDeliveryAvailability(
				store,
				userLocation,
				isPointInShape
			);

			if (isAvailable) {
				deliveryZonesAvailable = [...deliveryZonesAvailable, ...matchedZones];
				deliveryStores.push(storeWithDistance);
			}
		}

		deliveryStores.sort((a, b) => (a.distancia ?? 0) - (b.distancia ?? 0));

		return {
			stores: deliveryStores,
			deliveryZonesAvailable,
		};
	}
}
